import React from 'react';
import './Col2.scss';

// boostrap col doesn't work well when forcing a mobile screen to pdf size
// converting to pdg requires forcing a mobile screen to pdf size
const Col2 = ({ children, className = '', ...props }) => {

  const fixedClassName = className
    .replace(/\bcol-md-1\b/g, 'col2-1')
    .replace(/\bcol-md-2\b/g, 'col2-2')
    .replace(/\bcol-md-3\b/g, 'col2-3')
    .replace(/\bcol-md-4\b/g, 'col2-4')
    .replace(/\bcol-md-5\b/g, 'col2-5')
    .replace(/\bcol-md-6\b/g, 'col2-6')
    .replace(/\bcol-md-7\b/g, 'col2-7')
    .replace(/\bcol-md-8\b/g, 'col2-8')
    .replace(/\bcol-md-9\b/g, 'col2-9')
    .replace(/\bcol-md-10\b/g, 'col2-10')
    .replace(/\bcol-md-11\b/g, 'col2-11')
    .replace(/\bcol-md-12\b/g, 'col2-12')
    .replace(/\bcol\b/g, '')

  return (
    <div className={`col2 ${fixedClassName}`} {...props}>
      {children}
    </div>
  );
}
export default Col2;